export type Language = 'en' | 'es'

export const t = {
  en: {
    nav: {
      home: 'Home',
      services: 'Services',
      pricing: 'Pricing',
      gallery: 'Gallery',
      faq: 'FAQ',
      rescueMe: 'RESCUE ME NOW',
    },
    hero: {
      headline: 'MOVING CRITICAL? CALL THE FIGHTERS.',
      sub: "We don't just move boxes; we execute residential rescues. No hidden fees. Fixed pricing. The first all-in-one moving product in Florida.",
      cta: 'RESERVE MY RESCUE',
    },
    trustBar: {
      moves: 'Successful Rescues',
      rating: 'Google Rating',
      pricing: 'Fixed Pricing',
      licensed: 'Licensed & Insured',
    },
    howItWorks: {
      title: 'HOW IT WORKS',
      step1: {
        title: 'Request Your Rescue',
        desc: 'Fill out the form or call us. Get your fixed price in minutes.',
      },
      step2: {
        title: 'We Deploy',
        desc: 'Our uniformed squad arrives on time with all equipment.',
      },
      step3: {
        title: 'Mission Complete',
        desc: 'Everything in its place. No surprises on the bill.',
      },
    },
    booking: {
      title: 'REQUEST A RESCUE',
      sizeLabel: 'Select Size',
      sizeOptions: [
        { value: '1room', label: 'Studio/1 Room [$600 Tampa / $749 Orlando]' },
        { value: '2rooms', label: '2 Rooms' },
        { value: '3rooms', label: '3 Rooms' },
        { value: '4rooms', label: '4+ Rooms' },
      ],
      originLabel: 'Origin Address (Florida)',
      destLabel: 'Destination Address (Florida)',
      dateLabel: 'Moving Date',
      nameLabel: 'Full Name',
      emailLabel: 'Email Address',
      phoneLabel: 'Phone Number',
      submit: 'GET MY FIXED PRICE',
    },
    pricing: {
      title: 'FIXED PRICING PACKAGES',
      popular: 'MOST POPULAR',
      cta: 'GET A QUOTE',
      customQuote: 'Custom Quote',
      cards: [
        {
          title: 'UNIT 1: Studio/1 Room',
          features: [
            '2 Fighters',
            'Moving Truck',
            'Industrial Blankets',
            'Protective Plastic Wrap',
            '3-Hour Window',
          ],
        },
        {
          title: 'UNIT 2: 2 Rooms',
          features: [
            '3 Fighters',
            'Moving Truck',
            'Full Packing Service',
            'Industrial Blankets & Wrap',
            '4-Hour Window',
          ],
        },
        {
          title: 'UNIT 3: 3 Rooms',
          features: [
            '3 Fighters',
            'Moving Truck',
            'Full Packing Service',
            'Furniture Disassembly',
            '5-Hour Window',
          ],
        },
        {
          title: 'UNIT 4: 4+ Rooms',
          features: [
            '4+ Fighters',
            'Multiple Trucks',
            'Full VIP Service',
            'Specialty Items Handling',
            'Dedicated Coordinator',
          ],
        },
      ],
    },
    services: {
      title: 'OUR RESCUE PROTOCOLS',
      items: [
        {
          title: 'Residential Rescues',
          desc: 'House and apartment moves with a fixed price. No matter if there are stairs, we climb.',
        },
        {
          title: 'Commercial Extractions',
          desc: 'Fast office moves so your business never stops.',
        },
        {
          title: 'Packing & Protection',
          desc: 'Industrial blankets, protective plastic, and professional boxes included in every "Rescue".',
        },
        {
          title: 'Last Minute Dispatch',
          desc: 'Coordinated logistics in record time for fixed-date moves.',
        },
      ],
    },
    guarantee: {
      title: 'THE MOVE FIGHTERS GUARANTEE',
      sub: "If we're late, your move is on us.",
      items: ['No Hidden Fees', 'On-Time Arrival', 'Damage Protection'],
    },
    gallery: {
      title: 'FIGHTERS IN ACTION',
    },
    testimonials: {
      title: 'WHAT OUR RESCUED FAMILIES SAY',
      reviews: [
        {
          quote:
            'These guys are the real deal. Fixed price, no surprises, and they treated my furniture like it was theirs. Best movers in Tampa!',
          name: 'Maria G.',
          location: 'Tampa, FL',
          timeAgo: '2 months ago',
          color: 'bg-blue-500',
        },
        {
          quote:
            'I was stressed about my last-minute move but Move Fighters showed up on time and had everything done in 3 hours. Incredible.',
          name: 'James R.',
          location: 'Orlando, FL',
          timeAgo: '3 weeks ago',
          color: 'bg-red-500',
        },
        {
          quote:
            'True professionals. Fixed price, no surprises. My 3-bedroom move was perfect from start to finish.',
          name: 'Carlos M.',
          location: 'Miami, FL',
          timeAgo: '1 month ago',
          color: 'bg-green-500',
        },
      ],
    },
    coverage: {
      title: "FLORIDA'S LARGEST RESCUE NETWORK",
      subtitle: 'We cover the entire state, from the Panhandle to the Keys.',
    },
    faq: {
      title: 'FREQUENTLY ASKED QUESTIONS',
      items: [
        {
          q: 'Is the price really fixed?',
          a: 'Yes. Unlike others, we don’t charge for stairs, fuel, or traffic.',
        },
        {
          q: 'What if I need to change the date?',
          a: 'You get 2 free date changes with a 72h notice.',
        },
        {
          q: 'Are you licensed?',
          a: 'Move Fighters is fully licensed and insured in the State of Florida.',
        },
        {
          q: 'What areas do you cover?',
          a: 'We cover all of Florida, from Pensacola to Key West.',
        },
        {
          q: 'How far in advance should I book?',
          a: 'We recommend at least 72 hours, but we also handle last-minute rescues.',
        },
        {
          q: 'Do you disassemble and reassemble furniture?',
          a: 'Yes! Beds, tables, shelves — our Fighters handle it all at no extra cost.',
        },
      ],
    },
    finalCta: {
      title: 'READY FOR YOUR RESCUE?',
      sub: 'Join 500+ Florida families who chose the Fighters.',
      primaryBtn: 'RESERVE NOW',
      secondaryBtn: 'CALL US',
    },
    footer: {
      hq: 'Move Fighters LLC - Headquarters Florida. Licensed & Insured Moving Services.',
      privacy: 'Privacy Policy',
      terms: 'Terms of Service',
      refund: 'Refund Policy',
      careers: 'Careers (Join the Squad)',
      rights: '© 2024 Move Fighters. All Rights Reserved.',
    },
  },
  es: {
    nav: {
      home: 'Inicio',
      services: 'Servicios',
      pricing: 'Precios',
      gallery: 'Galería',
      faq: 'Preguntas',
      rescueMe: 'RESCÁTAME AHORA',
    },
    hero: {
      headline: '¿MUDANZA CRÍTICA? LLAMA A LOS FIGHTERS.',
      sub: 'No solo movemos cajas; ejecutamos rescates residenciales. Sin cargos ocultos. Precios fijos. El primer producto de mudanza todo-en-uno en Florida.',
      cta: 'RESERVAR MI RESCATE',
    },
    trustBar: {
      moves: 'Rescates Exitosos',
      rating: 'Calificación Google',
      pricing: 'Precios Fijos',
      licensed: 'Licencia y Seguro',
    },
    howItWorks: {
      title: 'CÓMO FUNCIONA',
      step1: {
        title: 'Solicita Tu Rescate',
        desc: 'Llena el formulario o llámanos. Obtén tu precio fijo en minutos.',
      },
      step2: {
        title: 'Desplegamos',
        desc: 'Nuestro escuadrón uniformado llega a tiempo con todo el equipo.',
      },
      step3: {
        title: 'Misión Cumplida',
        desc: 'Todo en su lugar. Sin sorpresas en la factura.',
      },
    },
    booking: {
      title: 'SOLICITAR UN RESCATE',
      sizeLabel: 'Seleccionar Tamaño',
      sizeOptions: [
        {
          value: '1room',
          label: 'Estudio/1 Habitación [$600 Tampa / $749 Orlando]',
        },
        { value: '2rooms', label: '2 Habitaciones' },
        { value: '3rooms', label: '3 Habitaciones' },
        { value: '4rooms', label: '4+ Habitaciones' },
      ],
      originLabel: 'Dirección de Origen (Florida)',
      destLabel: 'Dirección de Destino (Florida)',
      dateLabel: 'Fecha de Mudanza',
      nameLabel: 'Nombre Completo',
      emailLabel: 'Correo Electrónico',
      phoneLabel: 'Número de Teléfono',
      submit: 'OBTENER MI PRECIO FIJO',
    },
    pricing: {
      title: 'PAQUETES DE PRECIO FIJO',
      popular: 'MÁS POPULAR',
      cta: 'SOLICITAR COTIZACIÓN',
      customQuote: 'Cotización Personalizada',
      cards: [
        {
          title: 'UNIDAD 1: Estudio/1 Hab.',
          features: [
            '2 Fighters',
            'Camión de Mudanza',
            'Mantas Industriales',
            'Plástico Protector',
            'Ventana de 3 Horas',
          ],
        },
        {
          title: 'UNIDAD 2: 2 Habitaciones',
          features: [
            '3 Fighters',
            'Camión de Mudanza',
            'Servicio de Embalaje',
            'Mantas y Plástico',
            'Ventana de 4 Horas',
          ],
        },
        {
          title: 'UNIDAD 3: 3 Habitaciones',
          features: [
            '3 Fighters',
            'Camión de Mudanza',
            'Servicio de Embalaje',
            'Desarmado de Muebles',
            'Ventana de 5 Horas',
          ],
        },
        {
          title: 'UNIDAD 4: 4+ Habitaciones',
          features: [
            '4+ Fighters',
            'Múltiples Camiones',
            'Servicio VIP Completo',
            'Manejo de Artículos Especiales',
            'Coordinador Dedicado',
          ],
        },
      ],
    },
    services: {
      title: 'NUESTROS PROTOCOLOS DE RESCATE',
      items: [
        {
          title: 'Rescate Residencial',
          desc: 'Mudanzas de casas y apartamentos con precio cerrado. No importa si hay escaleras, nosotros subimos.',
        },
        {
          title: 'Mudanzas Comerciales',
          desc: 'Movimientos de oficinas rápidos para que tu negocio no se detenga.',
        },
        {
          title: 'Embalaje y Protección',
          desc: 'Mantas industriales, plástico protector y cajas profesionales incluidas en cada "Rescate".',
        },
        {
          title: 'Despacho de Prioridad',
          desc: 'Logística coordinada en tiempo récord para mudanzas con fecha fija.',
        },
      ],
    },
    guarantee: {
      title: 'LA GARANTÍA MOVE FIGHTERS',
      sub: 'Si llegamos tarde, tu mudanza es por nuestra cuenta.',
      items: [
        'Sin Cargos Ocultos',
        'Llegada Puntual',
        'Protección contra Daños',
      ],
    },
    gallery: {
      title: 'FIGHTERS EN ACCIÓN',
    },
    testimonials: {
      title: 'LO QUE DICEN NUESTRAS FAMILIAS RESCATADAS',
      reviews: [
        {
          quote:
            'Estos chicos son de verdad. Precio fijo, sin sorpresas, y trataron mis muebles como si fueran suyos. ¡Los mejores de Tampa!',
          name: 'Maria G.',
          location: 'Tampa, FL',
          timeAgo: 'hace 2 meses',
          color: 'bg-blue-500',
        },
        {
          quote:
            'Estaba estresado por mi mudanza de último minuto, pero Move Fighters llegó a tiempo y terminó todo en 3 horas. Increíble.',
          name: 'James R.',
          location: 'Orlando, FL',
          timeAgo: 'hace 3 semanas',
          color: 'bg-red-500',
        },
        {
          quote:
            'Profesionales de verdad. Precio fijo, sin sorpresas. Mi mudanza de 3 habitaciones fue perfecta.',
          name: 'Carlos M.',
          location: 'Miami, FL',
          timeAgo: 'hace 1 mes',
          color: 'bg-green-500',
        },
      ],
    },
    coverage: {
      title: 'LA RED DE RESCATE MÁS GRANDE DE FLORIDA',
      subtitle: 'Cubrimos todo el estado, desde el Panhandle hasta los Keys.',
    },
    faq: {
      title: 'PREGUNTAS FRECUENTES',
      items: [
        {
          q: '¿El precio es realmente fijo?',
          a: 'Sí. A diferencia de otros, no cobramos por escaleras, combustible o tráfico.',
        },
        {
          q: '¿Qué pasa si necesito cambiar la fecha?',
          a: 'Tienes 2 cambios de fecha gratis con 72h de aviso.',
        },
        {
          q: '¿Tienen licencia?',
          a: 'Move Fighters cuenta con licencia completa y seguro en el Estado de Florida.',
        },
        {
          q: '¿Qué áreas cubren?',
          a: 'Cubrimos toda Florida, desde Pensacola hasta Key West.',
        },
        {
          q: '¿Con cuánta anticipación debo reservar?',
          a: 'Recomendamos al menos 72 horas, pero también manejamos rescates de último minuto.',
        },
        {
          q: '¿Desarman y rearman muebles?',
          a: 'Sí. Camas, mesas, estantes — nuestros Fighters se encargan sin costo extra.',
        },
      ],
    },
    finalCta: {
      title: '¿LISTO PARA TU RESCATE?',
      sub: 'Únete a más de 500 familias de Florida que eligieron a los Fighters.',
      primaryBtn: 'RESERVAR AHORA',
      secondaryBtn: 'LLÁMANOS',
    },
    footer: {
      hq: 'Move Fighters LLC - Sede Florida. Servicios de Mudanza con Licencia y Seguro.',
      privacy: 'Política de Privacidad',
      terms: 'Términos de Servicio',
      refund: 'Política de Reembolso',
      careers: 'Carreras (Únete al Escuadrón)',
      rights: '© 2024 Move Fighters. Todos los derechos reservados.',
    },
  },
}
